const APP_SETTINGS = {
    PAGE_SIZE: 20,
    TITLE: "Sistema registro SNC"
}

export default APP_SETTINGS